import { render, staticRenderFns } from "./loadingBtn.vue?vue&type=template&id=89322254&scoped=true&"
import script from "./loadingBtn.vue?vue&type=script&lang=js&"
export * from "./loadingBtn.vue?vue&type=script&lang=js&"
import style0 from "./loadingBtn.vue?vue&type=style&index=0&id=89322254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89322254",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
